import React from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import Svg, { Path, Polygon } from 'react-native-svg';

interface BadgeProps {
  onPress: () => void;
}

const APPLE_LOGO_BODY =
  'M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09z';
const APPLE_LOGO_LEAF =
  'M15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701z';

export function AppStoreBadge({ onPress }: BadgeProps) {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [styles.badge, pressed && styles.pressed]}
      accessibilityRole="link"
      accessibilityLabel="Télécharger sur l'App Store"
    >
      <Svg width={24} height={28} viewBox="0 0 24 24">
        <Path d={APPLE_LOGO_BODY} fill="#ffffff" />
        <Path d={APPLE_LOGO_LEAF} fill="#ffffff" />
      </Svg>
      <View style={styles.textColumn}>
        <Text style={styles.smallText}>Download on the</Text>
        <Text style={styles.bigText}>App Store</Text>
      </View>
    </Pressable>
  );
}

export function GooglePlayBadge({ onPress }: BadgeProps) {
  return (
    <Pressable
      onPress={onPress}
      style={({ pressed }) => [styles.badge, pressed && styles.pressed]}
      accessibilityRole="link"
      accessibilityLabel="Disponible sur Google Play"
    >
      <Svg width={26} height={28} viewBox="0 0 20 22">
        <Polygon points="1,1 11.8,7 1,11" fill="#00E676" />
        <Polygon points="11.8,7 19,11 1,11" fill="#FF3D47" />
        <Polygon points="11.8,15 19,11 1,11" fill="#FFCE00" />
        <Polygon points="1,21 11.8,15 1,11" fill="#00C3FF" />
      </Svg>
      <View style={styles.textColumn}>
        <Text style={styles.smallText}>GET IT ON</Text>
        <Text style={styles.bigText}>Google Play</Text>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: '#000000',
    borderWidth: 1,
    borderColor: '#A6A6A6',
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 18,
    minWidth: 220,
  },
  pressed: {
    opacity: 0.75,
  },
  textColumn: {
    justifyContent: 'center',
  },
  smallText: {
    color: '#ffffff',
    fontSize: 11,
    letterSpacing: 0.5,
    lineHeight: 14,
  },
  bigText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 24,
  },
});
